<section class="features-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <h2 >Digital Transformation</h2>
        </div>

        <div class="tab features-list-tab">
            <ul class="tabs">
                <li><a href="#" class="bg-3a55ee">
                    <i class="flaticon-analytics"></i>
                    <span>Branding</span>
                </a></li>
                <li><a href="#" class="bg-3a55ee">
                    <i class="flaticon-achievement"></i>
                    <span>User Experience</span>
                </a></li>
                <li><a href="#" class="bg-3a55ee">
                    <i class="flaticon-seo"></i>
                    <span>SEO </span>
                </a></li>
                <li><a href="#" class="bg-3a55ee">
                    <i class="flaticon-digital-marketing"></i>
                    <span>Digital Marketing</span>
                </a></li>
               
                <li><a href="#" class="bg-3a55ee">
                    <i class="flaticon-shopping-cart"></i>
                    <span>Ecommerce</span>
                </a></li>
                <li><a href="#" class="bg-3a55ee">
                    <i class="flaticon-analysis"></i>
                    <span>Analytics</span>
                </a></li>
            </ul>

            <div class="tab_content">
                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title" style="font-size: small; text-transform: lowercase;">Your brand is how your customers perceive you whereever they interact with your business</span>
                                <h2>Branding</h2>
                                <p>In order to amplify the reach of your offerings, you'll want to focus on improving your branding online. We understand building a brand from grounds up that stands out is no easy task, but we are here to help you acheive exactly that.</p>
                               
                                <ul class="features-list">
                                    
                                    <li><span><i class="flaticon-tick"></i> Logo</span></li>
                                    <li><span><i class="flaticon-tick"></i> Content Creation</span></li>
                                    <li><span><i class="flaticon-tick"></i> Social Media</span></li>
                                    <li><span><i class="flaticon-tick"></i> Notifications</span></li>
                                    <li><span><i class="flaticon-tick"></i> Customer Engagement</span></li>
                                    <li><span><i class="flaticon-tick"></i> SEO</span></li>
                                </ul>
                            </div>
                        </div>

                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/branding.jpeg" alt="branding" title="Branding">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/ux.jpeg" alt="User Experience">
                            </div>
                        </div>

                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title" style="font-size: small; text-transform: lowercase;">At its core, website UX is a form of customer service</span>
                                <h2>User Experience</h2>
                                <p>UX for websites goes beyond creating an intuitive layout or making sure visitors know where and how to contact you. It’s about providing an experience that is specifically designed for your customer journey. </p>
                                <p>We have an experience in developing beautiful, responsive, secured & seamless experience for your website visitors to reach the desired result and give you a greater chance to convert them as a loyal customer. </p>
                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i>Responsive web design</span></li>
                                    <li><span><i class="flaticon-tick"></i>Fast page load</span></li>
                                    <li><span><i class="flaticon-tick"></i>Secured website</span></li>
                                    <li><span><i class="flaticon-tick"></i>User workflows</span></li>
                                    <li><span><i class="flaticon-tick"></i>User Personas</span></li>
                                    <li><span><i class="flaticon-tick"></i>Data analysis</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title" style="font-size: small; text-transform: lowercase;">make sure your customers can find you</span>
                                <h2>Search Engine Optimization</h2>
                                <p>SEO is a complex system of digital techniques, strategies and practices designed to increase quantity and quality of online traffic to your website through organic search results.</p>
                                <p>We help you to get your business discovered online in different search engines and to provide updated and accurate information about your products, services and latest updates from your store to your potential customers. All this through a single app, our <a href="https://portal.ewns.in" itemprop="url" title="Content Manage Portal, EWNS WebService Pvt Ltd">Content Management Portal</a></p>
                            </div>
                        </div>

                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/seo.jpeg" alt="Search Engine Optimization">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/marketing.jpeg" alt="image">
                            </div>
                        </div>

                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title" style="font-size: small; text-transform: lowercase;">Digital marketing gives you opportunity to reach targeted global audience</span>
                                <h2>Digital Marketing</h2>
                                <p>Digital marketing can often help you produce fast results by targeting an audience, who is already interested in your products or services that your business has to offer.</p>
                                <p>Some of the various methods employed by our team to help you acheive the desired Return on Investment (ROI) are mentioned below:</p>
                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i>Pay Per Click</span></li>
                                    <li><span><i class="flaticon-tick"></i>Content Marketing</span></li>
                                    <li><span><i class="flaticon-tick"></i>Social Media Marketing</span></li>
                                    <li><span><i class="flaticon-tick"></i>Affliate Marketing</span></li>
                                    <li><span><i class="flaticon-tick"></i>Email/SMS Marketing</span></li>
                                    <li><span><i class="flaticon-tick"></i>Inbound Marketing</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title" style="font-size: small; text-transform: lowercase;">give your business an opportunity to scale using our fully responsive ecommerce website</span>
                                <h2>Ecommerce Store</h2>
                                <p>As your online presence continuous to grow, you may like to start Ecommerce store front to sell your offerings online. Using our platform, one can easily create, manage online store and sell your products to anyone, anywhere.</p>
                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i>SSL encryption</span></li>
                                    <li><span><i class="flaticon-tick"></i>Responsive website</span></li>
                                    <li><span><i class="flaticon-tick"></i>Your domain</span></li>
                                    <li><span><i class="flaticon-tick"></i>Reduce operation cost</span></li>
                                    <li><span><i class="flaticon-tick"></i>99% uptime</span></li>
                                    <li><span><i class="flaticon-tick"></i>Secured payment</span></li>
                                </ul>
                            </div>
                        </div>

                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/ecommerce-store.jpeg" alt="Ecommerce Store Front">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tabs_item">
                    <div class="features-overview">
                        <div class="overview-image">
                            <div class="image">
                                <img src="assets/img/business-growth.jpeg" alt="Business Growth">
                            </div>
                        </div>

                        <div class="overview-content">
                            <div class="content">
                                <span class="sub-title" style="font-size: small; text-transform: lowercase;">learn from meaningful insights</span>
                                <h2>Analytics</h2>
                                <p>Get meaningful data from your website which can tell you about how your customers are reaching you and interacting with your website and ad campaigns. once you have these insights, you can make logical business decisions on how and where to focus your efforts to improve your online presence</p>
                                <ul class="features-list">
                                    <li><span><i class="flaticon-tick"></i>Recommendation systems</span></li>
                                    <li><span><i class="flaticon-tick"></i>Demand prediction</span></li>
                                    <li><span><i class="flaticon-tick"></i>Omnichannel analytics</span></li>
                                    <li><span><i class="flaticon-tick"></i>Lead generation</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
</section>